import yoda from '@ks/yoda-js-sdk';
import { defineComponent, onMounted, ref } from '@vue/composition-api';
import lottie from 'lottie-web';
import { lrpx2px, MNavBaroffsetTop, kpn } from '@/utils/device';
import { getStaticLocale } from '@/utils/locale';
import { openCreatorPage } from '@/utils/yoda';
import { cdnRetryList } from '@/utils/cdn';
export default defineComponent({
  props: {
    showTop: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    showRules: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      required: false
    },
    // ui用
    mainFixed: {
      type: Boolean,
      default: false
    },
    hide: {
      type: Boolean,
      default: false
    }
  },
  emits: ['left-click'],
  setup: function setup(props, ctx) {
    var isInApp = yoda.isInYoda;
    var navBarRef = ref(null);

    var handleBackClick = function handleBackClick(e) {
      ctx.emit('left-click', e);
    };

    var lottieRef = ref(null);

    var loadTitleAnimation = function loadTitleAnimation() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (index > 3) {
        return;
      }

      var origin = cdnRetryList[index];
      var path;

      if (getStaticLocale() === 'ar') {
        path = 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/fission/fission-title/ar/ar.json';
      } else if (getStaticLocale() === 'es') {
        path = 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/fission/fission-title/es/index.json';
      } else {
        path = ['pt', 'ur', 'id'].includes(getStaticLocale()) ? "https://cdn-static.kwai.net/kos/s101/nlav11312/creative/fission/fission-title/".concat(getStaticLocale(), ".json") : 'https://cdn-static.kwai.net/kos/s101/nlav11312/creative/fission/fission-title/en.json';
      }

      path = origin + new URL(path).pathname;
      var anim = lottie.loadAnimation({
        container: lottieRef.value,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: path
      });
      anim.addEventListener('data_failed', function () {
        loadTitleAnimation(index + 1);
      });
    };

    var isFixed = ref(false);

    var handleChangeFixed = function handleChangeFixed(val) {
      isFixed.value = val;
    };

    var toRules = function toRules() {
      var shareUid = new URL(window.location.href).searchParams.get('share_uid');
      openCreatorPage(ctx, '/fission/rules', shareUid ? {
        // 端外需要传inviterId
        inviterId: shareUid
      } : {});
    };

    onMounted(function () {
      loadTitleAnimation();
    }); // const 

    return {
      isInApp: isInApp,
      MNavBaroffsetTop: MNavBaroffsetTop,
      lrpx2px: lrpx2px,
      handleBackClick: handleBackClick,
      kpn: kpn,
      lottieRef: lottieRef,
      toRules: toRules,
      handleChangeFixed: handleChangeFixed,
      isFixed: isFixed
    };
  }
});